import Footer from '@/components/layout/footer';
import { NavbarCleaner } from '@/components/layout/navbar/navbar.cleaner';
import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import CleanerSidebar from '@/components/layout/sidebar/sidebar.cleaner';

export const Route = createFileRoute('/(cleaner)/_authenticated')({
  beforeLoad: ({ context }) => {
    // Check if user is authenticated
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: '/cleaner/login',
        search: {
          redirect: location.href,
        },
      });
    }
    // Check if user has the correct role for cleaner routes
    if (context.auth.user?.role !== 'cleaner') {
      throw redirect({
        to: '/dashboard',
      });
    }

    // Block cleaner app areas until background check is verified.
    if (context.auth.user?.ssn && !context.auth.user?.is_verified) {
      throw redirect({
        to: '/application-submitted',
      });
    }
  },
  component: CleanerAuthLayout,
});

function CleanerAuthLayout() {
  return (
    <div>
      <NavbarCleaner />
      <div className="max-w-7xl mx-auto px-4 py-6 mt-[50px] md:mt-[140px]">
        <div className="flex flex-col md:flex-row gap-0 md:gap-8">
          <div>
            <CleanerSidebar />
          </div>
          <div className="w-full">
            <Outlet />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
